import store from "@/store"
import videojs from "video.js"

class Hls {
  constructor() {
    this.init = false
    this.player = null
    this.currentTime = 0
    this.SEF_EVENT_TYPE = {
      CONNECTION_FAILED: 1,
      AUTHENTICATION_FAILED: 2,
      STREAM_NOT_FOUND: 3,
      NETWORK_DISCONNECTED: 4,
      NETWORK_SLOW: 5,
      RENDER_ERROR: 6,
      RENDERING_START: 7,
      RENDERING_COMPLETE: 8,
      STREAM_INFO_READY: 9,
      DECODING_COMPLETE: 10,
      BUFFERING_START: 11,
      BUFFERING_COMPLETE: 12,
      BUFFERING_PROGRESS: 13,
      CURRENT_DISPLAY_TIME: 14,
      AD_START: 15,
      AD_END: 16,
      RESOLUTION_CHANGED: 17,
      BITRATE_CHANGED: 18,
      SUBTITLE: 19,
      CUSTOM: 20
    }
  }
  _init = async () => {
    if (this.init) return true

    _$.vue.$on("mediaEnded", async () => {
      if (!__.media.getLoop()) return false
      if (__.platform.hasBackground()) __.platform.background(store.state.background.slides, __.media.getSource())
      else __.media.play(__.media.getSource(), true)
    })

    if (document.getElementById("videoplane")) document.getElementById("videoplane").remove()

    this._noReasonBugFix()

    _$.loader.createPlayer("object", {
      id: "pluginPlayer",
      class: "plugin",
      classid: "clsid:SAMSUNG-INFOLINK-SEF",
      style: "background:#000;"
    })

    this.player = document.getElementById("pluginPlayer")
    this.init = true

    return true
  }
  start = async () => {
    __._source.set(43)
    return true
  }
  destroy = async () => {
    await this.stop()
    this.player.Close()
    return true
  }

  play = async () => {
    const promise = await _$.progress.create(_$.progress.type.PLAY)
    if (promise.isResolved) return false

    promise.terminateAfter(8000)

    const { width, height, x, y } = __.common.tvWindowMetrics

    let source = __.media.getSource()
    if (!["mp4", "ts", "mov", "mkv"].includes(source.split(".").pop())) source += "|COMPONENT=HLS"

    /* Library Code */
    this.currentTime = 0
    this.player.Close()
    this.player.Open("Player", "1.000", "Player")
    this.player.OnEvent = (event, data1, data2) => this._onEvent(event, data1, data2)
    this.player.Execute("InitPlayer", source)
    this.player.Execute("StartPlayback")
    this.player.Execute("SetDisplayArea", 0.75 * x, 0.75 * y, 0.75 * width, 0.75 * height)
    /* Library Code */

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }
  stop = async () => {
    const promise = await _$.progress.create(_$.progress.type.STOP)

    /* Library Code */
    this.player.Execute("Stop")
    _$.handler.emit("stopped")
    /* Library Code */

    _$.vue.$once(["mediaStopped", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }
  pause = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    this.player.Execute("Pause")
    _$.handler.emit("pause")
    /* Library Code */

    _$.vue.$once(["mediaPaused", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }
  continue = async () => {
    const promise = await _$.progress.create()

    /* Library Code */
    this.player.Execute("Resume")
    /* Library Code */

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    return promise.done
  }

  /* Control Helpers */
  isSeekable = async () => {
    return this.player.Execute("GetDuration") ? true : false
  }
  getDuration = async () => {
    return this.player.Execute("GetDuration")
  }
  getPosition = async () => {
    return this.currentTime
  }
  setPosition = async second => {
    const promise = await _$.progress.create()

    let duration = this.getDuration()
    duration = Math.ceil(parseInt(duration, 10) / 1000)
    let diff = second - this.currentTime

    if (!second || second > duration) promise.reject()
    else {
      /* Library Code */
      if (diff > 0) this.player.Execute("JumpForward", diff)
      else if (diff < 0) this.player.Execute("JumpBackward", Math.abs(diff))
      /* Library Code */
    }
    promise.resolve()

    return promise.done
  }

  /* Language and Subtitles Helpers */
  getSubtitles = async () => {
    return false
  }
  setSubtitle = async () => {
    return true
  }
  closeSubtitle = async () => {
    return true
  }

  getLanguages = async () => {
    return false
  }
  setLanguage = async () => {
    return true
  }
  _onEvent(event, data1) {
    switch (event) {
      case this.SEF_EVENT_TYPE.CONNECTION_FAILED:
      case this.SEF_EVENT_TYPE.AUTHENTICATION_FAILED:
      case this.SEF_EVENT_TYPE.STREAM_NOT_FOUND:
      case this.SEF_EVENT_TYPE.NETWORK_DISCONNECTED:
      case this.SEF_EVENT_TYPE.RENDER_ERROR:
        _$.handler.emit("error")
        break
      case this.SEF_EVENT_TYPE.RENDERING_START:
        _$.handler.emit("playing")
        break
      case this.SEF_EVENT_TYPE.RENDERING_COMPLETE:
        _$.handler.emit("ended")
        break
      case this.SEF_EVENT_TYPE.CURRENT_DISPLAY_TIME:
        this.currentTime = Math.ceil(parseInt(data1, 10) / 1000)
        break
      default:
        break
    }
  }
  _noReasonBugFix() {
    _$.loader.createPlayer("video", {
      id: "videoplane",
      controls: false,
      poster: null,
      class: "VideoJS"
    })

    this.player = videojs("videoplane", {
      autoplay: true,
      controls: false,
      preload: "auto",
      children: []
    })
  }
}

export default Hls
